import React from 'react'
import { Message } from 'semantic-ui-react'
import Cookies from 'universal-cookie'
import { DSIHtml } from './dsi_html'

export const CampaignTagSignUpMessage = () => {
  const content = new Cookies().get('campaign_tag_message')
  if (!content || !content.length) return null

  return (
    <Message size="small" color="blue">
      <DSIHtml>{content.replace(/\+/g, ' ').replace(/\n/g, '<br/>')}</DSIHtml>
    </Message>
  )
}
